// src/main/technique_container.js
import { connect } from 'react-redux';
import CourseTechniquePage from './technique';
import { fetchAvailableCourses, fetchUserCourses } from '../../actions/course_actions';
import { logout } from '../../actions/session_actions';

const mapStateToProps = (state) => ({
  // try common shapes so we don’t get undefined
  courses:
    state?.course?.availableCourses ??
    [],
});

const mapDispatchToProps = (dispatch) => ({
  fetchAvailableCourses: () => dispatch(fetchAvailableCourses()),
  fetchUserCourses: (user_id) => dispatch(fetchUserCourses(user_id)),
  logout: (user) => dispatch(logout(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseTechniquePage);
